import { render, staticRenderFns } from "./StatsLeads.vue?vue&type=template&id=acfc9e5c"
import script from "./StatsLeads.vue?vue&type=script&lang=ts"
export * from "./StatsLeads.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports